import { render, staticRenderFns } from "./msDropdown.vue?vue&type=template&id=23f3df61&scoped=true"
import script from "./msDropdown.vue?vue&type=script&lang=js"
export * from "./msDropdown.vue?vue&type=script&lang=js"
import style0 from "./msDropdown.vue?vue&type=style&index=0&id=23f3df61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3df61",
  null
  
)

export default component.exports